import {
  Document,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  Packer,
  AlignmentType,
  WidthType,
  BorderStyle,
  TableLayoutType,
} from 'docx';
import moment from 'moment';

// ─── Утилиты ──────────────────────────────────────────────────────────────────

const createTextParagraph = (text, options = {}) => {
  const {
    bold = false,
    size = 12,
    alignment = AlignmentType.LEFT,
    spacingAfter = 200,
    font = 'Times New Roman',
  } = options;

  return new Paragraph({
    children: [
      new TextRun({
        text: text || '',
        bold,
        size: size * 2,
        font: { name: font },
      }),
    ],
    alignment,
    spacing: { after: spacingAfter },
  });
};

const createCenteredParagraph = (text, bold = true, size = 12) =>
  createTextParagraph(text, { bold, size, alignment: AlignmentType.CENTER });

// Ширины колонок таблицы (7 логических колонок):
// № | ФИО | Должность,КК | Образ.учреждение | Баллы ОУ | Баллы Эксп. | Замечания
const COLUMN_WIDTHS = [5, 20, 13, 17, 7, 10, 28];

const convertHtmlTableToDocxTable = (tableId) => {
  const tableElement = document.getElementById(tableId);
  if (!tableElement) return null;

  const getCellWidth = (logicalColIndex, colspan) => {
    let width = 0;
    for (let i = 0; i < colspan; i++) {
      width += COLUMN_WIDTHS[logicalColIndex + i] || 10;
    }
    return width;
  };

  const rows = [];
  Array.from(tableElement.querySelectorAll('tr')).forEach((tr) => {
    const cells = [];
    let logicalCol = 0;
    Array.from(tr.querySelectorAll('td, th')).forEach((td) => {
      const text = td.textContent?.trim() || '';
      const colspan = parseInt(td.getAttribute('colspan') || '1', 10);
      const rowspan = parseInt(td.getAttribute('rowspan') || '1', 10);
      cells.push(
        new TableCell({
          children: [
            new Paragraph({
              children: [new TextRun({ text, size: 16, font: { name: 'Times New Roman' } })],
              alignment: AlignmentType.CENTER,
              spacing: { after: 50 },
            }),
          ],
          width: { size: getCellWidth(logicalCol, colspan), type: WidthType.PERCENTAGE },
          columnSpan: colspan > 1 ? colspan : undefined,
          rowSpan: rowspan > 1 ? rowspan : undefined,
          borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
            left: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
            right: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
          },
          verticalAlign: 'center',
        })
      );
      logicalCol += colspan;
    });
    rows.push(new TableRow({ children: cells }));
  });

  return new Table({
    rows,
    width: { size: 100, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
  });
};

// ─── Основная функция ─────────────────────────────────────────────────────────

const getWordSenapsisRemarks = async ({ comission, userInfo }) => {
  const { last_name, first_name, patronymic } = userInfo;
  const createrName = `${last_name || ''} ${first_name || ''} ${patronymic || ''}`;
  const now = moment();

  const content = [];

  content.push(
    createCenteredParagraph('СПРАВКА', true, 12),
    createCenteredParagraph('замечаний по итогам экспертизы аттестационных материалов (портфолио)', true, 12),
    createCenteredParagraph('педагогических работников', true, 12),
    createCenteredParagraph(`${now.format('MMMM')} ${now.year()} года`, true, 12)
  );

  const docxTable = convertHtmlTableToDocxTable('synopsisRemarksTable');
  if (docxTable) content.push(docxTable);

  content.push(
    createTextParagraph(`Кто создал: ${createrName}`, { size: 8, alignment: AlignmentType.LEFT, spacingAfter: 50 }),
    createTextParagraph(`Дата: ${moment(comission.date_to).format('DD.MM.YYYY')}`, { size: 8, alignment: AlignmentType.LEFT, spacingAfter: 50 }),
    createTextParagraph('Документ сформирован в системе управления обучением', { size: 8, alignment: AlignmentType.LEFT })
  );

  const doc = new Document({
    styles: { default: { document: { run: { font: 'Times New Roman', size: 24 } } } },
    sections: [
      {
        properties: { page: { margin: { top: 1000, bottom: 1000, left: 1140, right: 1140 } } },
        children: content,
      },
    ],
  });

  return Packer.toBlob(doc);
};

export default getWordSenapsisRemarks;
